import * as z from 'zod';
import { AdjustableValue } from '../../../financial-formula/adjustable-value.mjs';
import '../../../financial-formula/adjustable-values-update.mjs';
import '../../../financial-formula/adjustment.mjs';
import '../../../financial-formula/formula.mjs';
import '@inrev/core';
import { LineItemGroup } from './line-item-group.mjs';

var IncomeStatementWithAdjustments;
(function (IncomeStatementWithAdjustments) {
    IncomeStatementWithAdjustments.schema = z.object({
        revenue: LineItemGroup.schema,
        cogs: AdjustableValue.schema.nullable(),
        operatingExpenses: AdjustableValue.schema.nullable(),
        otherIncome: AdjustableValue.schema.nullable(),
        otherExpenses: AdjustableValue.schema.nullable(),
        taxes: AdjustableValue.schema.nullable(),
        profitable: z.boolean().nullish(),
        depreciation: AdjustableValue.schema.nullable(),
        amortization: AdjustableValue.schema.nullable(),
        depreciationAndAmortization: AdjustableValue.schema.nullable(),
        interestExpense: AdjustableValue.schema.nullable(),
        incomeTaxes: AdjustableValue.schema.nullable(),
        irregularGainLossFromAssetSale: AdjustableValue.schema.nullable(),
        distributions: AdjustableValue.schema.nullable(),
    });
})(IncomeStatementWithAdjustments || (IncomeStatementWithAdjustments = {}));

export { IncomeStatementWithAdjustments };
